import { Switch, Route } from 'react-router-dom'
import { Path } from 'config/constants/paths'
import Menu, { MinerMoleMenu, GotchiMenu } from './components/Menu'

import { VvsMainProviders, MinerMoleProviders, GotchiProviders } from './Providers'

const LayoutWithMenu = ({ children }) => {
  return (
    <Switch>
      <Route path={Path.VVS_GOTCHI_MOLE_PERFORMANCE}>{children}</Route>
      <Route path={Path.VVS_MINER_MOLE}>
        <MinerMoleProviders>
          <MinerMoleMenu>{children}</MinerMoleMenu>
        </MinerMoleProviders>
      </Route>
      <Route path={Path.VVS_GOTCHI}>
        <GotchiProviders>
          <GotchiMenu>{children}</GotchiMenu>
        </GotchiProviders>
      </Route>
      <Route path="/">
        <VvsMainProviders>
          <Menu>{children}</Menu>
        </VvsMainProviders>
      </Route>
    </Switch>
  )
}

export default LayoutWithMenu
